import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import {SertifikatFiskalnogRacunaDropdownService} from '../sertifikat-fiskalnog-racuna-dropdown.service';
import { storageUrlClean } from '../../../../../../apps/core/src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SertifikatFiskalnogRacunaInterceptorService implements HttpInterceptor {
  constructor(
    private _sertifikatService: SertifikatFiskalnogRacunaDropdownService
  ) {}

  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (!req.url.includes(storageUrlClean)) {
      req = this._sertifikatService.applyHeaderFilter(req);
    }

    return next.handle(req).pipe();
  }
}
